<template>
  <div
    v-if="isLoadingPickup"
    v-loading="isLoadingPickup"
    class="mt-5"
  />

  <el-row
    v-else
    :gutter="15"
  >
    <el-col
      :xs="12"
      :sm="8"
      :md="7"
      :lg="6"
      :xl="4"
    >
      <el-card
        shadow="never"
        header="Pickups"
      >
        <el-menu
          :default-active="activePickup"
          class="border-0"
          @select="index => { activePickup = index }"
        >
          <el-menu-item :index="pickup.booking_reference">
            <span class="pr-2">{{ pickup.booking_reference }}</span>
            <el-tag
              size="mini"
              type="info"
            >
              Current Pickup
            </el-tag>
          </el-menu-item>

          <el-menu-item
            v-for="(previousPickup, index) in previousPickups"
            :key="index"
            :index="previousPickup.booking_reference"
          >
            <span class="pr-2">{{ previousPickup.booking_reference }}</span>
            <el-tag
              size="mini"
              type="info"
            >
              {{ index === (previousPickups.length - 1) ? 'Original Pickup' : `Rebooking of ${previousPickups[index + 1].booking_reference}` }}
            </el-tag>
          </el-menu-item>
        </el-menu>
      </el-card>
    </el-col>

    <el-col
      :xs="12"
      :sm="16"
      :md="17"
      :lg="18"
      :xl="20"
    >
      <Filters
        ref="filters"
        :resource="$sdk.note"
        :filters.sync="filters"
        class="mb-3"
        @apply="() => $refs['notes'].reload()"
        @ready="() => $refs['notes'].load()"
      />

      <el-card shadow="never">
        <Notes
          ref="notes"
          :resource="$sdk.pickup"
          :identifier="noteIdentifier"
          paginate
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Complex'
import Notes from '@/components/Notes'
import { CREATED } from '@/plugins/sdk/Events'

export default {
  components: {
    Filters,
    Notes
  },
  data () {
    return {
      title: 'Notes',
      breadcrumb: {
        name: 'All Notes',
        route: { name: 'customerservice-pickups-pickup-notes', params: { pickupId: this.$route.params.pickupId } }
      },
      actions: [
        {
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => this.$refs['notes'].create()
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.$refs['notes'].reload()
        }
      ],
      isLoadingPickup: true,
      filters: [],
      pickup: undefined,
      previousPickups: [],
      activePickup: undefined
    }
  },
  computed: {
    noteIdentifier () {
      const identifier = this.$route.params.pickupId

      if (typeof this.activePickup !== 'undefined' &&
        this.pickup instanceof this.$sdk.pickup &&
        this.activePickup !== this.pickup.booking_reference) {
        return this
          .previousPickups
          .find(pickup => pickup.booking_reference === this.activePickup)
          .id
      }

      return identifier
    }
  },
  watch: {
    activePickup (value) {
      this
        .$router
        .push({ query: { pickup: value } })
    },
    noteIdentifier () {
      if (this.$refs['filters']) {
        this.$refs['filters'].clear()
      }
    }
  },
  created () {
    this.activePickup = this.$route.query.pickup

    this
      .$sdk
      .pickup
      .read(this.$route.params.pickupId)
      .then(res => {
        let pickup = res
        this.pickup = pickup

        if (typeof this.activePickup === 'undefined') {
          this.activePickup = this.pickup.booking_reference
        }

        while (pickup.previous_pickup instanceof this.$sdk.pickup) {
          this.previousPickups.push(pickup.previous_pickup)
          pickup = pickup.previous_pickup
        }
      })
      .finally(() => { this.isLoadingPickup = false })
  },
  mounted () {
    this
      .$sdk
      .note
      .on(CREATED, () => {
        this.activePickup = this.pickup.booking_reference
      }, this)
  }
}
</script>
